export default __webpack_public_path__ + "static/media/service24.fbfd44b6.png";